import { IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { loraGatewayOn, loraGatewayOff, loraSensorOn, loraSensorOff, airOn, airOff, coOn, coOff } from '@assets/images/main/index';

export default {
  bannerData: [
    {
      icon: loraGatewayOn,
      iconInv: loraGatewayOff,
      image: '',
      iconText: 'LoRa<br/>Gateway',
      sub: 'New',
      link: '/en/sensor/LoRaGateway'
    },
    {
      icon: loraSensorOn,
      iconInv: loraSensorOff,
      image: '',
      iconText: 'LoRa<br/>Sensor',
      sub: 'New',
      link: '/en/sensor/LoRaSensor'
    },
    {
      icon: airOn,
      iconInv: airOff,
      image: '',
      iconText: 'Air Quality<br/>Monitor',
      sub: 'New',
      link: '/en/sensor/air'
    },
    {
      icon: coOn,
      iconInv: coOff,
      image: '',
      iconText: 'Carbon Monoxide<br/>Monitor',
      sub: '',
      link: '/en/sensor/co'
    },
    {
        icon: IconOsOn,
        iconInv: IconOsOff,
        image: '',
        iconText: 'ORBRO OS',
        sub: 'New',
        link: '/en/os'
    },

  ],
}
